(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/hooks/use-campaign.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/hooks/use-campaign.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useState
} = React;
const {
  getCampaign,
  calculateChances
} = svs.numbergames.campaign;
const {
  isKeno
} = svs.numbergames.productMapping;
const useCampaign = _ref => {
  let {
    game,
    draw
  } = _ref;
  const [campaignData, setCampaignData] = useState();
  useEffect(() => {
    if (!isKeno(game.productItsId)) return;
    (async () => {
      const numberOfChances = await calculateChances({
        product: game.productItsId,
        wager: _objectSpread(_objectSpread({
          betAmount: game.price
        }, game), {}, {
          rowCount: game.boards.length
        }),
        productDraws: [draw]
      });
      const campaign = await getCampaign({
        product: game.productItsId
      });
      if (numberOfChances) {
        setCampaignData(_objectSpread({
          numberOfChances
        }, campaign));
      }
    })();
  }, [game, draw]);
  return campaignData;
};
svs.gamePackage.hooks.useCampaign = useCampaign;

 })(window);